class BeschikbaarheidRelationListCtrl {
    constructor(BeschikbaarheidRelationApi, DoclrModalService, praktijkContext, notificationService, calendars, sortByProperty) {
        'ngInject';

        this.BeschikbaarheidRelationApi = BeschikbaarheidRelationApi;
        this.DoclrModalService = DoclrModalService;
        this.praktijkContext = praktijkContext;
        this.notificationService = notificationService;
        this.calendars = calendars;
        this.sortByProperty = sortByProperty
    }

    $onInit() {
        this._loadRelations();
    }

    onAdd() {
        this.BeschikbaarheidRelationApi
            .findAllAvailableAppointmentTypes(this._getBeschikbaarheidId())
            .then((availableAppointmentTypes) => {
                const sortedTypes = availableAppointmentTypes
                    .filter(t => this._ifMultiThanParentShouldBeMultiDiscipline(t)) //Enforce multi in the hierarchy
                    .filter(t => this._ifNotMultiParentThanFilterOnDiscipline(t)) //Filter on discipline if not multi
                    .sort(this.sortByProperty(t => doclrVertaal.translateTypeWithTypePrefix(t)))
                this._openAddModal(sortedTypes);
            });
    }

    onEdit(relation) {

        let context = {
            beschikbaarheid: this.beschikbaarheid,
            model: relation.beschikbaarheidRelation,
            appointmentType: relation.appointmentType,
            calendars: this.calendars,
            toggleCalendar: this.toggleCalendar,
            containsCalendar: this.containsCalendar,
            variableTimes: relation.beschikbaarheidRelation.variableTime
                ? relation.beschikbaarheidRelation.variableTime.split(";")
                    .map(x => {
                        return {value: parseInt(x)};
                    })
                : [],
            addVariableTime: function () {
                this.variableTimes.push({value: 1});
            },
            removeVariableTime: function (index) {
                this.variableTimes.splice(index, 1);
            }
        };

        this.DoclrModalService.openEditModal(
            '/partials/beschikbaarheidtypes/beschikbaarheideleation.edit.modal.html', context)
            .then(() => {
                relation.beschikbaarheidRelation.variableTime = context.variableTimes.map(x => x.value.toString()).join(";");
                this._onApplyEditRelation(relation.beschikbaarheidRelation)
            }, () => {
            });
    }

    toggleCalendar(calendarId) {
        let calenderToToggle = '(' + calendarId + ')';

        if (!this.model.calendars) {
            this.model.calendars = '';
        }

        if (this.model.calendars.indexOf(calenderToToggle) < 0) {
            this.model.calendars += calenderToToggle;
        } else {
            this.model.calendars = this.model.calendars.replace(calenderToToggle, '');
        }
    }

    containsCalendar(calendarId) {
        if (!this.model.calendars) {
            return false;
        }

        return this.model.calendars.indexOf(calendarId) >= 0;
    }

    moveSorting(relation, positionMove) {
        let index = this.beschikbaarheidRelations.map(x => x.beschikbaarheidRelation.id).indexOf(relation.beschikbaarheidRelation.id);
        let newRelations = [...this.beschikbaarheidRelations];
        newRelations[index + positionMove] = this.beschikbaarheidRelations[index];
        newRelations[index] = this.beschikbaarheidRelations[index + positionMove];
        this.beschikbaarheidRelations = newRelations

        let relationIds = newRelations.map(x => x.beschikbaarheidRelation.id);

        this.BeschikbaarheidRelationApi.changeSorting(relation.beschikbaarheidRelation.beschikbaarheidId, {sortedRelations: relationIds})
    }

    onDelete(relation) {
        this.DoclrModalService.openConfirmModal(doclrVertaal.instant('beschaarheid.relation.verwijderen.title'), doclrVertaal.instant('beschaarheid.relation.verwijderen.question'))
            .then(() => this.BeschikbaarheidRelationApi.remove(relation.beschikbaarheidRelation.id, relation.beschikbaarheidRelation.beschikbaarheidId))
            .then(() => this._loadRelations(), this._loadRelations())
            .then(() => this.notificationService.showSuccess(doclrVertaal.instant('beschaarheid.relation.verwijderd')));
    }

    _openAddModal(availableAppointmentTypes) {
        let newRelation = {
            partyId: this.praktijkContext.id,
            beschikbaarheidId: this._getBeschikbaarheidId(),
            multiplicity: 1,
            bufferBefore: 0,
            bufferAfter: 0,
            hasCalendarFilter: false,
            calendars: '',
            hasVariableTime: false,
            variableTime: '',
        };

        this.DoclrModalService.openAddModal(
            '/partials/beschikbaarheidtypes/beschikbaarheideleation.add.modal.html',
            {
                beschikbaarheid: this.beschikbaarheid,
                availableAppointmentTypes: availableAppointmentTypes,
                model: newRelation,
                calendars: this.calendars,
                toggleCalendar: this.toggleCalendar,
                containsCalendar: this.containsCalendar
            })
            .then(() => this._onApplyAddRelation(newRelation), () => {
            });

    }

    _onApplyAddRelation(newbeschikbaarheidRelation) {
        this.BeschikbaarheidRelationApi.create(newbeschikbaarheidRelation)
            .then(() => this._loadRelations())
            .then(() => this.notificationService.showSuccess(doclrVertaal.instant('beschaarheid.relation.edit.toegevoegd')));
    }

    _onApplyEditRelation(newbeschikbaarheidRelation) {
        this.BeschikbaarheidRelationApi.update(newbeschikbaarheidRelation)
            .then(() => this._loadRelations())
            .then(() => this.notificationService.showSuccess(doclrVertaal.instant('beschaarheid.relation.edit.gewijzigd')));

    }

    _loadRelations() {
        this.BeschikbaarheidRelationApi
            .findAll(this._getBeschikbaarheidId())
            .then((relations) => {
                this.beschikbaarheidRelations = this._sortRelations(relations)
            });
    }

    _ifMultiThanParentShouldBeMultiDiscipline(type) {
        if (type.multiDiscipline) {
            return this.beschikbaarheid.multiDiscipline;
        }
        return true;
    }

    _ifNotMultiParentThanFilterOnDiscipline(type) {
        if (!this.beschikbaarheid.multiDiscipline) {
            return type.disciplineName === this.beschikbaarheid.disciplineName;
        }
        return true;
    }

    _getBeschikbaarheidId() {
        return this.beschikbaarheid.id.split('/').pop();
    }

    _sortRelations(relations) {
        return relations.sort(this.sortByProperty(x => x.beschikbaarheidRelation.sortNumber));
    }
}

(function () {
    'use strict';

    angular.module('doclr.beschikbaarheidrelation')
        .component('beschikbaarheidRelationList', {
            templateUrl: '/partials/beschikbaarheidtypes/beschikbaarheidrelation.list.component.html',
            controller: BeschikbaarheidRelationListCtrl,
            controllerAs: 'beschikbaarheidRelationListVM',
            bindings: {
                beschikbaarheid: '<'
            }
        });
})();